import {socket} from '@/plugins/socket';

export default {
    mounted() {
        this._payrollSubscribe = () => {
            if (this.$store.state.token) socket.emit('payroll:subscribe', {token: this.$store.state.token});
        };
        this._payrollChanged = event => {
            // Other months can also belong to the open comparison/history range.
            this.analyticsRevision++;
            if (!event || !event.period_id || this.summary && Number(this.summary.period.id) === event.period_id) this.refreshPayrollBackground();
        };
        this._payrollFocus = () => { if (!document.hidden) { this._payrollSubscribe(); this.refreshPayrollBackground(); } };
        socket.on('connect', this._payrollFocus);
        socket.on('payroll:changed', this._payrollChanged);
        if (socket.connected) this._payrollSubscribe(); else socket.connect();
        document.addEventListener('visibilitychange', this._payrollFocus);
        window.addEventListener('focus', this._payrollFocus);
        this._payrollPoll = setInterval(() => {
            if (!document.hidden) { this._payrollSubscribe(); if (!this.canViewCalculation) this.refreshPayrollBackground(); }
        }, 30000);
    },
    beforeDestroy() {
        this._payrollRealtimeClosed = true;
        clearInterval(this._payrollPoll);
        socket.off('connect', this._payrollFocus); socket.off('payroll:changed', this._payrollChanged);
        socket.emit('payroll:unsubscribe');
        document.removeEventListener('visibilitychange', this._payrollFocus);
        window.removeEventListener('focus', this._payrollFocus);
    },
    watch: {
        pending(value) { if (!value && this._payrollRefreshQueued) this.refreshPayrollBackground(); },
        loading(value) { if (!value && this._payrollRefreshQueued) this.refreshPayrollBackground(); },
        '$store.state.token'() { if (this._payrollSubscribe) this._payrollSubscribe(); }
    },
    methods: {
        async refreshPayrollBackground() {
            if (!this.summary || this._payrollRealtimeClosed) return;
            if (this.pending || this._payrollRefreshing || this.loading) { this._payrollRefreshQueued = true; return; }
            if (this.canViewCalculation && (this.editVisible || this.reasonVisible || this.ratesDirty || this.missingRateDirty)) return;
            this._payrollRefreshQueued = false; this._payrollRefreshing = true;
            try { await this.loadSummary(null, true); }
            finally {
                this._payrollRefreshing = false;
                if (this._payrollRefreshQueued && !this._payrollRealtimeClosed) this.refreshPayrollBackground();
            }
        }
    }
};
